import api from './api';

export const userPreferencesService = {
  getDashboard: () => api.get('/user-preferences/dashboard'),
  updateDashboard: (data) => api.put('/user-preferences/dashboard', data),
};
